export default __webpack_public_path__ + "static/12-80adaf4a601ee8a9104e2d020fdcbde1.jpg";